import axiosInstance from "../interceptor/interceptor";
import dictionary from "../dictionary";

const { chat } = dictionary;

const chatServices = {
  createChatSession: (body: any) => axiosInstance.post(chat?.createChat(), body),
  getAllChatSessions: (body: any) => axiosInstance.post(chat?.getAllChats(), body),
  sendMessage: (chatId: string, body: any) => axiosInstance.post(chat?.sendMessage(chatId), body),
  getMessagesForChat: (body: any) => axiosInstance.get(chat?.getMessages(body)),
  getChatFeatureStatus: (body: any) => axiosInstance.post(chat?.getChatStatus(), body),
};

export default chatServices;
